import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./modal.scss";
import crossbtn from "../../assets/images/delete-button.png";
import { useStores } from "../../stores";
import notify from "../../shared/notify";
import Loader from "../../helper/Loader/Loader";

const EditModal = (props) => {
  const { authStore } = useStores();
  const [expenditure, setExpenditure] = useState(props?.data?.name);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    setIsLoading(true);
    let payload = {
      name: expenditure,
    };
    props.hide();

    await authStore.editExpenditure(
      props.data.id,
      payload,
      (response) => {
        if (response?.data?.meta?.status === "success") {
          notify(response?.data?.meta?.message, "success");
          setIsLoading(false);
          props.onSubmit();
        } else {
          notify(response?.data?.meta?.message, "danger");
          setIsLoading(false);
        }
      },
      (error) => {
        notify(error?.response?.data?.meta?.message, "danger");
        setIsLoading(false);
      }
    );
  };

  return (
    <Modal {...props} centered className="sucess-content">
      <Modal.Body className="sucess-modal">
        <div className="">
          {isLoading && <Loader />}
          <h4 className="modal-heading">Edit Expenditure</h4>
          <div className="moodal">
            <div
              className="crossbtn-container"
              onClick={() => props.hide()}
              style={{ textAlign: "right" }}
            >
              <img
                className="crossbutton"
                src={crossbtn}
                alt="..."
                style={{
                  width: "28px",
                  position: "absolute",
                  right: "10px",
                  top: "17px",
                }}
              />
            </div>
            <div className="addName-model">
              <label className="input-lable">Expenditure Head</label>
              <br />
              <input
                class="form-control"
                type="text"
                placeholder="Expenditure Head"
                value={expenditure}
                onChange={(e) => {
                  let data = e.target.value.toUpperCase();
                  setExpenditure(data)
                }
                }
              />
            </div>
          </div>
          <div className="text-right mt-3">
            <button className="submit-button text-right" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditModal;
